import { CalendarEventOccurrenceTarget } from '@griply/types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ApplyToOccurrencesDialog } from 'shared/dialogs/apply-to-occurrences';

export type EventApplyToOccurrencesDialogProps = {
  onSelect: (occurrenceTarget: CalendarEventOccurrenceTarget) => void;
  onClose: () => void;
};

// Binds the calendar-event copy onto the shared prompt; both the save path and the drag
// path ask the same question, so neither owns the wording.
export const EventApplyToOccurrencesDialog: React.FC<
  EventApplyToOccurrencesDialogProps
> = ({ onSelect, onClose }) => {
  const { t } = useTranslation();

  const onSingle = () => onSelect(CalendarEventOccurrenceTarget.Single);
  const onSeries = () => onSelect(CalendarEventOccurrenceTarget.Series);

  return (
    <ApplyToOccurrencesDialog
      open
      abovePopups
      title={t('forms.event.occurrence-target.title')}
      message={t('forms.event.occurrence-target.description')}
      singleLabel={t('forms.event.occurrence-target.single')}
      allLabel={t('forms.event.occurrence-target.series')}
      onSingle={onSingle}
      onAll={onSeries}
      onCancel={onClose}
    />
  );
};
